<template lang="pug">
.management-wrapper

  b-modal(v-model='showSaveEmailModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SaveEmailModal(:booking="booking"
                    @close='props.close'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showSendOfferModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendOfferModal(:booking="booking"
                    @close='props.close'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showSendContractModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendContractModal(:booking="booking"
                    @close='props.close'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showPaymentModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      PaymentModal(:booking="booking"
                    @close='props.close'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showSendCancelModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendCancelModal(:booking="booking"
                    @close='props.close'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showSendCancelInvoiceModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendCancelInvoiceModal(:booking="booking"
                    @close='props.close'
                    @refreshInbox="refreshInbox()")


  .filter
    .filter-item-wrapper
      b-dropdown(aria-role='list')
        button.button.is-primary(slot='trigger' slot-scope='{ active }')
          span Neuer Vorgang
          b-icon(:icon="active ? 'menu-up' : 'menu-down'")
        b-dropdown-item(aria-role='listitem' @click="showSaveEmailModal = true") E-Mail speichern
        //- b-dropdown-item(aria-role='listitem' @click="showSendOfferModal = true") Angebot versenden
        //- b-dropdown-item(aria-role='listitem' @click="showSendContractModal = true") Mietvertrag versenden
        //- b-dropdown-item(v-if="booking.bookingStatus.uuid === 'STATUS_CONTRACT_RECEIVED'" aria-role='listitem' @click="showPaymentModal = true") Zahlung empfangen
        //- b-dropdown-item(v-if="booking.bookingStatus.uuid === 'STATUS_CONTRACT_RECEIVED'" aria-role='listitem' @click="showSendCancelModal = true") Stornieung versenden
        //- b-dropdown-item(v-if="booking.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED'" aria-role='listitem' @click="showSendCancelInvoiceModal = true") Stornorechnung versenden

    .filter-item-wrapper(:class="{active: activeItem === 'all'}" @click="activeItem = 'all'")
      b-icon(icon="inbox") 
      .filter-item Alles
    .filter-item-wrapper(:class="{active: activeItem === 'receive'}" @click="activeItem = 'receive'")
      b-icon(icon="email-receive-outline") 
      .filter-item Empfangen
    .filter-item-wrapper(:class="{active: activeItem === 'send'}" @click="activeItem = 'send'")
      b-icon(icon="email-send-outline") 
      .filter-item Gesendet
    .filter-item-wrapper(:class="{active: activeItem === 'offer'}" @click="activeItem = 'offer'")
      b-icon(icon="tag-outline") 
      .filter-item Angebote
    .filter-item-wrapper(:class="{active: activeItem === 'contract'}" @click="activeItem = 'contract'")
      b-icon(icon="file-document-outline") 
      .filter-item Mietverträge
    .filter-item-wrapper(:class="{active: activeItem === 'cancelInvoice'}" @click="activeItem = 'cancelInvoice'")
      b-icon(icon="file-cancel-outline") 
      .filter-item Stornierungen
  .overview
    template(v-for="historyPoint in fullHistory")
      .entry-item-wrapper(v-if="historyPoint.type === 'send' || historyPoint.type === 'receive'" @click="activeEmail = historyPoint")
        .entry-item {{historyPoint.subject}}
        .bottom
          .icon
            b-icon(v-if="historyPoint.type==='receive'" icon="email-receive-outline")
            b-icon(v-else-if="historyPoint.type==='send'" icon="email-send-outline")
          .subline {{new Date(historyPoint.inboxDate).toLocaleDateString('de-DE', dateOptions)}}
          .attachement-count(v-if="attachementCount(historyPoint) > 0") {{attachementCount(historyPoint) === 1 ? attachementCount(historyPoint)+' Anhang': attachementCount(historyPoint) + ' Anhänge'}}
      .entry-item-wrapper(v-else @click="openFile(historyPoint.type, historyPoint.id)")
        .entry-item {{historyPoint.name}}
        .bottom
          .icon
            b-icon(icon="paperclip")
          .subline {{new Date(historyPoint.createdAt).toLocaleDateString('de-DE', dateOptions)}}

  .detail-view
    template(v-if="activeEmail")
      .attachements
        .attachement(v-for="attachement, idx in activeEmail.emailAttachements" @click="openAttachement('email', attachement)")
          .name {{attachement.name}}
      .email-date
        |{{activeEmail.type === 'send' ? 'Gesendet am ' : 'Empfangen am '}}
        |{{new Date(activeEmail.inboxDate).toLocaleDateString('de-DE', dateOptions)}}
      .email-subject {{activeEmail.subject}}
      .email-body(v-html="activeEmail.body")
</template>

<script>
import FileType from 'file-type/browser';
import SaveEmailModal from "@/components/molecules/SaveEmailModal.vue";
import SendOfferModal from "@/components/molecules/SendOfferModal.vue";
import SendContractModal from "@/components/molecules/SendContractModal.vue";
import PaymentModal from "@/components/molecules/PaymentModal.vue";
import SendCancelModal from "@/components/molecules/SendCancelModal.vue";
import SendCancelInvoiceModal from "@/components/molecules/SendCancelInvoiceModal.vue";

export default {
  components: {
    SaveEmailModal,
    SendOfferModal,
    SendContractModal,
    PaymentModal,
    SendCancelInvoiceModal,
    SendCancelModal
  },
  props: {
    booking: {
      type: Object
    }
  },
  data() {
    return {
      activeItem: 'all',
      showSaveEmailModal: false,
      showSendOfferModal: false,
      showSendContractModal: false,
      showPaymentModal: false,
      showSendCancelInvoiceModal: false,
      showSendCancelModal: false,
      activeEmail: null,
      activeFile: null,
      dateOptions: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }
    };
  },
  computed: {
    fullHistory() {
      let history = [];
      history = history.concat(this.files);
      history = history.concat(this.emails);
      return history.sort(function(a,b){
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
    },
    files() {
      let files = [];
      if (this.activeItem === 'all') {
        files = files.concat(this.booking.offers.map(o => ({...o, type: 'offers'})));
        files = this.booking.parentContract ? files.concat(this.booking.parentContract.contracts.map(o => ({...o, type: 'contracts'}))) : files;
        files = files.concat(this.booking.cancelInvoices.map(o => ({...o, type: 'cancelInvoices'})));
        files = files.concat(this.booking.rentObjectBookingAttachments.map(o => ({...o, type: 'rentObjectBookingAttachments'})));
        files = files.concat(this.booking.paymentReminders.map(o => ({...o, type: 'paymentReminders'})));
        return files;
      } else if (this.activeItem === 'offer') {
        files = files.concat(this.booking.offers.map(o => ({...o, type: 'offers'})));
        return files;
      } else if (this.activeItem === 'contract') {
        if (!this.booking.parentContract) return files;
        files = files.concat(this.booking.parentContract.contracts.map(o => ({...o, type: 'contracts'})));
        return files;
      } else if (this.activeItem === 'cancelInvoice') {
        files = files.concat(this.booking.cancelInvoices.map(o => ({...o, type: 'cancelInvoices'})));
        return files;
      }
      return []
    },
    emails() {
      if (this.activeItem === 'all') {
        return this.$store.state.emails.all;
      } else if (this.activeItem === 'send') {
        return this.$store.state.emails.all.filter(e => e.type === 'send');
      } else if (this.activeItem === 'receive') {
        return this.$store.state.emails.all.filter(e => e.type === 'receive');
      } else if (this.activeItem === 'offer') {
        return this.$store.state.emails.all.filter(e => !!e.emailAttachements.filter(a => a.type === 'offer').length > 0);
      } else if (this.activeItem === 'contract') {
        return this.$store.state.emails.all.filter(e => !!e.emailAttachements.filter(a => a.type === 'contract').length > 0);
      } else if (this.activeItem === 'cancelInvoice') {
        return this.$store.state.emails.all.filter(e => !!e.emailAttachements.filter(a => a.type === 'cancelInvoice').length > 0);
      }
      return []
    },
    emailAttachements() {
      if (!this.activeEmail || !this.activeEmail.emailAttachements || !this.activeEmail.offers) return 0;
      return this.activeEmail.emailAttachements.concat(this.activeEmail.offers);
    }
  },
  async mounted() {
    await this.$store.dispatch('emails/findAll', {rentObjectBookingId: this.booking.id});
  },
  methods: {
    attachementCount(email) {
      if (!email || !email.emailAttachements || !email.offers) return 0;
      return email.emailAttachements.length + email.offers.length + email.contracts.length + email.cancelInvoices.length
    },
    async refreshInbox() {
      await this.$store.dispatch('emails/findAll', {rentObjectBookingId: this.booking.id});
      this.$emit('refreshBooking');
    },
    async openFile(dest, fileId) {
      const newFile = await this.$store.dispatch(`${dest}/getAttachement`, {id: fileId});
      const filetype = await FileType.fromBuffer(newFile);
      let file = new Blob([newFile], { type: filetype.mime });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    },
    async openAttachement(dest, attachement) {
      let newFile;
      if (dest === 'offer') {
        newFile = await this.$store.dispatch('offers/getAttachement', {id: attachement.id});
      } else if (dest === 'contract') {
        newFile = await this.$store.dispatch('contracts/getAttachement', {id: attachement.id});
      } else if (dest === 'email') {
        newFile = await this.$store.dispatch('emails/getAttachement', {id: attachement.id});
      } else if (dest === 'cancelInvoice') {
        newFile = await this.$store.dispatch('cancelInvoices/getAttachement', {id: attachement.id});
      } else if (dest === 'attachment') {
        newFile = await this.$store.dispatch('rentObjectBookingAttachments/getAttachement', {id: attachement.id});
      }
      const file = new Blob([newFile], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }
  }
}
</script>

<style lang="scss" scoped>
.management-wrapper {
  display: grid;
  grid-template-areas: "filter overview detail";
  grid-template-columns: 200px 320px auto;
  height: calc(100vh - 342px);
  border-radius: 3px;
  border: solid 1px $light;
  overflow: hidden;
}

.filter {
  grid-area: filter;
  background-color: white;
  .filter-item-wrapper {
    padding: $sm-space;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: $lightgray;
    font-size: 0.9rem;
    &:hover {
      color: $black;
    }
    &.active {
      color: $primary;
      font-weight: bold;
    }
    cursor: pointer;
    .filter-item {
      margin-left: $sm-space;
    }
  }
}

.overview {
  grid-area: overview;
  background-color: $lightgray;
  overflow-y: auto;
  .entry-item-wrapper {
    border-radius: 3px;
    background-color: white;
    box-shadow: $shadow-lg;
    margin: $xs-space;
    padding: $sm-space;
    cursor: pointer;
    transition: all 0.24s ease;
    &:hover {
      // transform: translateX(-#{$xs-space});
      // border-left:solid $xs-space $primary;
      background-color: $light;
    }
    .bottom {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin:  0 $sm-space;
      .attachement-count {
        background-color: $light;
        border-radius: 99px;
        padding: 1px 6px;
        font-size: 0.8rem;
        margin-left: $sm-space;
      }
      .subline {
        font-size: 0.8rem;
        color: $darkgray;
        margin-left: $md-space;
      }
    }
    .entry-item {
      font-weight: 500;
      margin-bottom: $xs-space;
    }
    .bottom {
      margin-top: $sm-space;
      color: $darkgray;
    }
  }
}

.detail-view {
  grid-area: detail;
  background-color: white;
  padding: $sm-space;
  overflow-y: auto;
  .attachement {
    padding: $xs-space;
    border-radius: 3px;
    background-color: $light;
    display: inline-block;
    margin-right: $xs-space;
    margin-bottom: $xs-space;
    box-shadow: $shadow-lg;
    border: solid 1px $lightgray;
    cursor: pointer;
  }

  .email-date {
    font-size: 0.8rem;
    color: $darkgray;
    margin-top: $xs-space;
  }

  .email-subject {
    font-size: 1.2rem;
    font-weight: bold;
    margin-top: 4px;
    margin-bottom: $sm-space;
  }
}
</style>